export const ADMIN_CHECK_START = 'ADMIN_CHECK_START';
export const ADMIN_CHECK_SUCCESS = 'ADMIN_CHECK_SUCCESS';
export const ADMIN_CHECK_FAIL = 'ADMIN_CHECK_FAIL';
